import { Reducer } from "redux";

import {
	VendorClientActions,
	VendorClientActionTypes
} from "../../../actions/Vendor/Client";

export interface VendorClientState {
	readonly isLoading: boolean;
	readonly editClientDrawerVisible: boolean;
}

export const initialVendorClientState: VendorClientState = {
	isLoading: false,
	editClientDrawerVisible: false
};

export const VendorClientReducer: Reducer<
	VendorClientState,
	VendorClientActions
> = (
	state: VendorClientState = initialVendorClientState,
	action: VendorClientActions
): VendorClientState => {
	switch (action.type) {
		case VendorClientActionTypes.SHOW_VENDOR_CLIENT_LOADER: {
			return {
				...state,
				isLoading: true
			};
		}
		case VendorClientActionTypes.HIDE_VENDOR_CLIENT_LOADER: {
			return {
				...state,
				isLoading: false
			};
		}
		case VendorClientActionTypes.OPEN_EDIT_VENDOR_CLIENT_DRAWER:
			return {
				...state,
				editClientDrawerVisible: true
			};
		case VendorClientActionTypes.CLOSE_EDIT_VENDOR_CLIENT_DRAWER:
			return {
				...state,
				editClientDrawerVisible: false
			};
		default: {
			return state;
		}
	}
};

export default VendorClientReducer;
